import { Mode } from './constants';
export const getFormFields = (formData, formConfig, errorMessages = {}, viewMode) => {
    const formFields = [];
    formConfig.map(field => {
        const config = field.configCallback
            ? field.configCallback(field)
            : field.config || {};
        const val = formData[field.key] === null || formData[field.key] === undefined
            ? ''
            : formData[field.key];
        const newField = {
            id: field.key,
            elementType: field.elementType,
            config,
            value: viewMode === Mode.VIEW
                ? field[val] || val
                : typeof val === 'boolean'
                    ? val.toString()
                    : val,
            ...(field.config.type === 'file' && { file: formData?.file }),
            ...(field.config.type === 'file' && {
                iconBase64String: formData?.iconBase64String,
            }),
            valid: field.valid,
            validation: errorMessages[field.key]
                ? { ...field.validation, error: errorMessages[field.key] }
                : field.validation,
            valueLabels: field.valueLabels,
        };
        if (errorMessages[field.key]) {
            newField.valid = false;
        }
        formFields.push(newField);
    });
    return formFields;
};
export const parseFormData = (currentFormData = []) => {
    const formData = {};
    currentFormData.forEach((i) => {
        formData[i.id] = ['true', 'false'].includes(i.value)
            ? i.value === 'true'
            : i.value;
    });
    return formData;
};
export const getOrgViewMode = (currentOrgId) => {
    if (currentOrgId === -1) {
        return 'all';
    }
    if (currentOrgId === 0) {
        return 'primary';
    }
    return '';
};
//# sourceMappingURL=utils.js.map